import "./index.css";

import App from "./App";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import authMessage from "./store/reducers/auth-message.reducer";
import { configureStore } from "@reduxjs/toolkit";
import languageReducer from "./store/reducers/language.reducer";
import reportWebVitals from "./reportWebVitals";

const store = configureStore({
  reducer: {
    lang: languageReducer,
    authLayout: authMessage,
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
